import type { GoogleLoginRequest } from '@apm/contracts';

/**
 * `POST /v1/auth/google` 의 본문을 만든다 (v17 R1).
 *
 * ── 왜 순수 함수인가 ─────────────────────────────────────────
 *
 * **이 한 줄이 v16 내내 빠져 있었다.** 계약(`GoogleLoginRequest.deviceId`)에도, 서버
 * DTO 에도, `promoteProgress` 에도, 통합 테스트에도 자리가 있었는데 **앱만 보내지
 * 않았다** — 하네스와 통합 테스트는 자기 손으로 `deviceId` 를 실어 보내므로 전부
 * 초록이었고, **실제 구글 로그인에서는 시청 진행 승격이 한 번도 돈 적이 없다.**
 * 증상은 「로그인했더니 이어보기가 처음으로 돌아갔다」 하나이고 그것이
 * `docs/38` D6 이 막으려던 바로 그것이다.
 *
 * 그래서 본문 조립을 훅에서 떼어 **node 환경 테스트가 잡을 수 있는 자리**로 옮긴다
 * (`client-type.ts`·`login-mode.ts` 와 같은 이유 — jsdom 미도입).
 *
 * ── 빈 값이면 키 자체를 싣지 않는다 ──────────────────────────
 *
 * 서버는 `deviceId === ''` 를 무동작으로 처리하므로 결과는 같다. 그래도 싣지 않는 것은
 * **「기기를 모른다」와 「기기가 빈 문자열이다」가 기록에서 구분되어야** 하기 때문이고,
 * 계약이 그 필드를 선택으로 둔 뜻이 그것이다.
 */
export function googleLoginBody(idToken: string, deviceId: string | null): GoogleLoginRequest {
  const trimmed = deviceId?.trim() ?? '';
  return trimmed === '' ? { idToken } : { idToken, deviceId: trimmed };
}
